import React, { MouseEventHandler, ReactNode } from "react";
import styled from "styled-components";

type ClassName = {
  className: string;
};

type Props = {
  readonly onClick?: MouseEventHandler<HTMLAnchorElement>;
  readonly align: "left" | "right";
  readonly type?: "link" | "button";
  readonly color?: "primary" | "secondary" | "base" | "error";
  readonly disabled?: boolean;
  readonly children?: ReactNode;
};

export default function PageMenuItem({
  children,
  onClick,
  align,
  type = "link",
  color = "primary",
  disabled = false,
}: Props) {
  if (type === "link") {
    let classNames = ``;
    if (disabled) {
      classNames = `${classNames} k-state-disabled`;
    }
    return (
      <StyledLink align={align} onClick={onClick} className={classNames}>
        {children}
      </StyledLink>
    );
  }

  return (
    <StyledButton onClick={onClick} color={color} align={align} disabled={disabled}>
      {children}
    </StyledButton>
  );
}

type ButtonProps = Omit<Props, "type">;
function StyledButton({ onClick, color, align, disabled, children }: ButtonProps) {
  let classNames = `k-button k-button-md k-button-rectangle k-button-solid k-button-solid-${color} k-rounded-md`;
  if (disabled) {
    classNames = `${classNames} k-state-disabled`;
  }
  return (
    <StyledHeaderButton onClick={onClick} align={align} className={classNames}>
      {children}
    </StyledHeaderButton>
  );
}

const StyledHeaderButton = styled.a<ButtonProps & ClassName>`
  cursor: pointer;
  position: relative;
  top: -5px;
  height: fit-content;
  ${(props: ButtonProps) => (props.align === "left" ? "margin-right:auto;" : "")}
`;

const StyledLink = styled.a<ButtonProps & ClassName>`
  cursor: pointer;
  color: #777;

  ${(props: ButtonProps) => (props.align === "left" ? "margin-right:auto;" : "")}
  &:hover {
    color: #333;
  }
`;
